import React from 'react';
import c from 'classnames';
import AnimateHeight from 'react-animate-height';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

// Due to webpack issues, we currently can't update the Unc Inc
// React Kitchen Sink package to its latest version. So this
// fork represents the latest version.
//
// @TODO:
// Remove this fork of the Unc Inc React Kitchen Sink component,
// when we update this package to the latest version.
const ContentParsed = ({ children }) => {
  if (typeof children === 'string') {
    return (<WysiwygField html={children} />);
  }

  return (
    <div>{ children }</div>
  );
};

const AccordeonTitle = ({ className, children }) => {
  return <h3 className={className}>{ children }</h3>;
};

const CustomAccordionItem = (props) => {
  const {
    title,
    content,
    iconClassName,
    duration,
    easing,
    titleComponent,
    className,
    collapsed,
    onChange,
  } = props;

  const classes = c(className, 'Accordion__item', {
    collapsed: collapsed,
  });
  const iconClasses = c('icon', iconClassName);
  const AccordeonTitle = titleComponent;

  return (
    <div className={classes}>
      <AccordeonTitle className="Accordion__item__title">
        <button type="button" onClick={() => onChange(!collapsed)}>
          <span className={iconClasses} />
          { title }
        </button>
      </AccordeonTitle>
      <AnimateHeight
        duration={duration}
        easing={easing}
        height={collapsed ? 0 : 'auto'}
      >
        <div className="Accordion__item__content">
          <ContentParsed>{ content }</ContentParsed>
        </div>
      </AnimateHeight>
    </div>
  );
};

CustomAccordionItem.defaultProps = {
  title: 'Default title',
  content: 'Default content',
  iconClassName: 'icon--arrow-right icon--variant-1',
  duration: 333,
  easing: 'cubic-bezier(0, 0, .2, 1)',
  titleComponent: AccordeonTitle,
};

export default CustomAccordionItem;

